import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BiUser } from 'react-icons/bi'
import { CgMail } from 'react-icons/cg'
import { MdPassword } from 'react-icons/md'
import { PiPhone } from 'react-icons/pi'
import { useDispatch } from 'react-redux'
import { Button, Col, Form, FormGroup, Input, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { fetchUserCreate } from '../../redux/slices/userCreateSlice'
import { fetchUserGet } from '../../redux/slices/userGetSlice'

const CrudUser = ({ addUserModal, setAddUserModal, selectedItem, setSelectedItem, getData }) => {
    const [formData, setFormData] = useState({ firstName: "", lastName: "", userName: "", email: "", phoneNumber: "", password: "", retyPassword: "", company: "", phone2: "", fax: "", address: "" })
    const dispatch = useDispatch()
    const { t } = useTranslation();

    const getUser = async () => {
        var data = await dispatch(fetchUserGet({ id: selectedItem }))
        if (data.payload) {
            setFormData({
                firstName: data?.payload?.firstName,
                lastName: data?.payload?.lastName,
                userName: data?.payload?.userName,
                email: data?.payload?.email,
                phoneNumber: data?.payload?.phoneNumber,
            })
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        await dispatch(fetchUserCreate({
            firstName: formData.firstName,
            lastName: formData.lastName,
            userName: formData.userName,
            email: formData.email,
            phoneNumber: formData.phoneNumber,
            password: formData.password
        }))
        getData()
        setAddUserModal(false)
        setFormData({ firstName: "", lastName: "", userName: "", email: "", phoneNumber: "", password: "", retyPassword: "", company: "", phone2: "", fax: "", address: "" })
    }

    useEffect(() => { getUser() }, [dispatch, selectedItem])

    return (
        <Modal isOpen={addUserModal} toggle={() => { setAddUserModal(!addUserModal); setSelectedItem(0) }} centered size="xl">
            <ModalHeader className='border-0' toggle={() => { setAddUserModal(!addUserModal); setSelectedItem(0) }}>
                <strong className='color3 fw500'>{t("user_edit")}</strong>
            </ModalHeader>
            <ModalBody className='pt-1'>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <span className='color3 mb-2 d-block f14'>{t("name")}</span>
                                <div className='form-element'>
                                    <BiUser size={18} />
                                    <Input type='text' value={formData.firstName} onChange={(e) => setFormData({ ...formData, firstName: e.target.value })} />
                                </div>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <span className='color3 mb-2 d-block f14'>{t("surname")}</span>
                                <div className='form-element'>
                                    <BiUser size={18} />
                                    <Input type='text' value={formData.lastName} onChange={(e) => setFormData({ ...formData, lastName: e.target.value })} />
                                </div>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <span className='color3 mb-2 d-block f14'>{t("username")}</span>
                                <div className='form-element'>
                                    <BiUser size={18} />
                                    <Input type='text' value={formData.userName} onChange={(e) => setFormData({ ...formData, userName: e.target.value })} />
                                </div>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <span className='color3 mb-2 d-block f14'>{t("eposta")}</span>
                                <div className='form-element'>
                                    <CgMail size={18} />
                                    <Input type='email' value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                                </div>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <span className='color3 mb-2 d-block f14'>{t("phone")}</span>
                                <div className='form-element'>
                                    <PiPhone size={18} />
                                    <Input type='text' value={formData.phoneNumber} onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })} />
                                </div>
                            </FormGroup>
                        </Col>
                        {selectedItem === 0 ? <Col md={6}>
                            <FormGroup>
                                <span className='color3 mb-2 d-block f14'>{t("password")}</span>
                                <div className='form-element'>
                                    <MdPassword size={18} />
                                    <Input type='password' onChange={(e) => setFormData({ ...formData, password: e.target.value })} />
                                </div>
                            </FormGroup>
                        </Col> : null}
                        {selectedItem === 0 ? <Col md={6}>
                            <FormGroup>
                                <span className='color3 mb-2 d-block f14'>{t("rety_password")}</span>
                                <div className='form-element'>
                                    <MdPassword size={18} />
                                    <Input type='password' onChange={(e) => setFormData({ ...formData, retyPassword: e.target.value })} />
                                </div>
                            </FormGroup>
                        </Col> : null}
                        <Col md={12}>
                            <div className='d-flex justify-content-end'>
                                <Button color={'primary'}>{t("add")}</Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default CrudUser
